import React, { useState, useEffect } from 'react';
import './Banner.css';

const Banner: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: '/images/banner1.jpg',
      title: 'Garcias Milho Premium',
      subtitle: 'Milho selecionado com grãos suculentos e sabor marcante'
    },
    {
      image: '/images/banner2.jpg',
      title: 'Qualidade Garantida',
      subtitle: 'Perfeito para pratos típicos, acompanhamentos ou receitas criativas'
    },
    {
      image: '/images/banner3.jpg',
      title: 'Tradição e Sabor',
      subtitle: 'A escolha certa para supermercados, restaurantes e estabelecimentos'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide(currentSlide === 0 ? slides.length - 1 : currentSlide - 1);
  };

  const goToNext = () => {
    setCurrentSlide((currentSlide + 1) % slides.length);
  };

  return (
    <section className="banner">
      <div className="banner-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${slide.image})`
            }}
          >
            <div className="banner-content">
              <h2>{slide.title}</h2>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        ))}
        
        <button className="banner-nav prev" onClick={goToPrevious}>
          &#8249;
        </button>
        <button className="banner-nav next" onClick={goToNext}>
          &#8250;
        </button>
        
        <div className="banner-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Banner;
